<template>
  <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
</template>
